<template>
    <svg
        width="14"
        height="6"
        viewBox="0 0 14 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M12.1875 3.75C12.6855 3.75 13.125 4.18945 13.125 4.6875C13.125 5.21484 12.6855 5.625 12.1875 5.625H0.9375C0.410156 5.625 0 5.21484 0 4.6875C0 4.18945 0.410156 3.75 0.9375 3.75H12.1875ZM12.1875 0C12.6855 0 13.125 0.439453 13.125 0.9375C13.125 1.46484 12.6855 1.875 12.1875 1.875H0.9375C0.410156 1.875 0 1.46484 0 0.9375C0 0.439453 0.410156 0 0.9375 0H12.1875Z"
            fill="black"
            fill-opacity="0.5"
        />
    </svg>
</template>
